import type { DigitalAssetType } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

const BASE_KEY = "company-analysis";

const COMPANY_ANALYSIS_SETTINGS_QUERY_KEY = "base-settings";
const SIGNAL_EVENTS_QUERY_KEY = "signal-events";
const COMPANY_CARD_QUERY_KEY = "company-card";
const COMPANY_BASE_INFO_QUERY_KEY = "company-base-info";
const COMPANY_DOMAIN_INFO_QUERY_KEY = "company-domain-info";
const CONTACTS_COUNTRIES_QUERY_KEY = "contacts-count-by-countries";
const DIGITAL_ASSETS_QUERY_KEY = "digital-assets";
const COMPANY_TECHNOLOGIES_QUERY_KEY = "company-technologies";
const COMPANY_COMPETITORS_QUERY_KEY = "company-competitors";
const GEO_BREAKDOWN_QUERY_KEY = "geo-breakdown";

export const companyAnalysisQueryKeys = {
    settings: (domain: string) => [BASE_KEY, COMPANY_ANALYSIS_SETTINGS_QUERY_KEY, domain] as const,

    signalEventsBase: (domain: string) => [BASE_KEY, SIGNAL_EVENTS_QUERY_KEY, domain] as const,
    signalEvents: (domain?: string, take?: number) => {
        const base = [BASE_KEY, SIGNAL_EVENTS_QUERY_KEY] as const;

        if (!is.undefined(domain)) {
            return [...companyAnalysisQueryKeys.signalEventsBase(domain), take?.toString() || "all"] as const;
        }

        return base;
    },

    companyCardBase: () => [BASE_KEY, COMPANY_CARD_QUERY_KEY] as const,
    companyCard: (domain: string) => [BASE_KEY, COMPANY_CARD_QUERY_KEY, domain] as const,

    companyBaseInfo: (domain: string) => [BASE_KEY, COMPANY_BASE_INFO_QUERY_KEY, domain] as const,

    companyDomainInfo: (domain: string) => [BASE_KEY, COMPANY_DOMAIN_INFO_QUERY_KEY, domain] as const,

    contactsCountByCountries: (domain: string) => [BASE_KEY, CONTACTS_COUNTRIES_QUERY_KEY, domain] as const,

    digitalAssetsBase: () => [BASE_KEY, DIGITAL_ASSETS_QUERY_KEY] as const,
    digitalAssets: (assetType: DigitalAssetType, domain: string) =>
        [...companyAnalysisQueryKeys.digitalAssetsBase(), assetType, domain] as const,

    technologies: (domain: string, isWebsiteAnalysis: boolean) =>
        [BASE_KEY, COMPANY_TECHNOLOGIES_QUERY_KEY, domain, isWebsiteAnalysis.toString()] as const,

    competitorsBase: () => [BASE_KEY, COMPANY_COMPETITORS_QUERY_KEY] as const,
    competitors: (domain: string, includeSignalsCount: boolean) =>
        [BASE_KEY, COMPANY_COMPETITORS_QUERY_KEY, domain, includeSignalsCount.toString()] as const,

    geoBreakdown: (domain: string) => [BASE_KEY, GEO_BREAKDOWN_QUERY_KEY, domain] as const,
};
